import React from 'react'

import {
  notEmpty,
  type SortColumnProps,
  type StandardTable,
} from '../../../module'
import MobileSideDrawerOptions from '../../SideDrawer/MobileSideDrawerOptions/MobileSideDrawerOptions'

type StandardTableProps = React.ComponentProps<typeof StandardTable>

type MobileColumnOptionsProps = {
  config: StandardTableProps['config']
  localStorageName: string
  sort: SortColumnProps['sorter']
  sortBy: SortColumnProps['active']
  setActiveColumn: (header: SortColumnProps['label']) => void
  activeSecondaryColumn: SortColumnProps['label']
  drawerCloseCallout?: (arg: boolean) => void
}

const MobileColumnOptions = ({
  config,
  localStorageName,
  sort,
  setActiveColumn,
  sortBy,
  activeSecondaryColumn,
  drawerCloseCallout,
}: MobileColumnOptionsProps): React.JSX.Element => {
  const transformedHeaders =
    config?.filter((h) => {
      return !h.mainColumn && !h.noSort && notEmpty(h.label) ? h : null
    }) ?? []

  const mobileColumnSelection = (header: {
    label: SortColumnProps['label']
    name: SortColumnProps['propName']
    lowerCaseParam?: SortColumnProps['lowerCaseParam']
  }) => {
    const propNameCheck = header.name === sortBy.prop,
      dir = propNameCheck ? !sortBy.flip : sortBy.flip,
      keyName = header.name ?? ''
    localStorage.setItem(
      localStorageName,
      JSON.stringify({
        prop: keyName,
        flip: dir,
        lowerCaseParam: header.lowerCaseParam,
      }),
    )
    sort({
      activeColumn: keyName,
      direction: dir,
      lowerCaseParam: header.lowerCaseParam,
    })
    setActiveColumn(header.label)
    drawerCloseCallout?.(false)
  }

  return (
    <MobileSideDrawerOptions
      options={transformedHeaders}
      callout={mobileColumnSelection}
      activeRow={activeSecondaryColumn}
    />
  )
}

export default MobileColumnOptions
